import { HeaderStyled } from './styled';

import clsx from 'clsx';
import { kindToName } from 'src/libraries/health';
import { IRobot } from 'src/types/firebase';

interface HeaderProps {
  className?: string;
  robot?: IRobot;
}

const Header = ({ className, robot }: HeaderProps) => {
  return (
    <HeaderStyled className={clsx('Header', className)}>
      <div className="title">
        {robot?.setting.status &&
          ['MEASURE', 'REST'].includes(robot?.setting.status) && (
            <>
              {kindToName(robot?.setting.health_kind)} <br />
              {robot?.setting.status === 'REST' ? '휴식중' : '운동 하는중'}
            </>
          )}
        {robot?.setting.status === 'MOVING' && <>목적지로 이동중</>}
        {robot?.setting.status === 'MEASURE_END' && <>운동 종료!</>}
      </div>
    </HeaderStyled>
  );
};

export default Header;
